import { HIS_VOICE_OPTIONS } from '../HIS_VOICE_OPTIONS';
import { HisVoiceOptionIdType } from '../types';

export const getHisVoiceTitleById = (
  id: HisVoiceOptionIdType | null | undefined,
): string | null => {
  if (!id) return null;
  return HIS_VOICE_OPTIONS.find((option) => option.id === id)?.title || null;
};

const DEFAULT: HisVoiceOptionIdType = 'deep_slow';
export const getHisVoiceIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): HisVoiceOptionIdType | null => {
  const id = HIS_VOICE_OPTIONS.find((option) => option.title === title)?.id;
  if (id) {
    return id;
  }
  if (withDefault) {
    return DEFAULT;
  }
  return null;
};
